import React from "react"
import PropTypes from "prop-types"
import { graphql, useStaticQuery } from "gatsby"
import SideLatestPosts from "../../components/side-latest-post"
import { LatestPostInnerWrap, LatestPostHeader, LatestPostBox } from "./style"
const LatestPostArea = (props) => {
    // const sideLatestPostsQuery = useStaticQuery(graphql`
    //     query SideLatestPostsQuery {
    //         latestPost: allMarkdownRemark(
    //             sort: {fields: [frontmatter___date], order: DESC},
    //             limit: 5
    //           ) {
    //             edges {
    //                 node {
    //                     id
    //                     frontmatter {
    //                         title
    //                         date(formatString: "DD MMMM YYYY")
    //                         format
    //                         is_featured
    //                         thume_image {
    //                             childImageSharp {
    //                                 gatsbyImageData(width: 84, height: 84, quality: 100)
    //                             }
    //                         }
    //                     }
    //                     fields {
    //                         slug
    //                         dateSlug
    //                     }
    //                 }
    //             }
    //         }
    //
    //     }
    // `);
    const sideLatestPostsQuery = useStaticQuery(graphql`
        query SideLatestPostsQuery {
  latestPost: allMongodbArchivosBlogDetails(
    sort: {fields: [jfrontmatter___date], order: DESC}
    limit: 5
    filter: {esPublicado: {eq: true}}
  ) {
    edges {
      node {
        id
        jfrontmatter {
          title
          date(formatString: "DD MMMM YYYY")
          is_featured
          thume_image
        }
        jfields {
          slug
          dateSlug
        }
        localThume {
          childImageSharp {
            gatsbyImageData(width: 84, height: 84, quality: 100)
          }
        }
      }
    }
  }
}

    `)
    const sideLatestPostsData = sideLatestPostsQuery.latestPost.edges

    return (
        <LatestPostInnerWrap>
            <LatestPostHeader>
                <div className="section-title">
                    <h3>Últimos posts</h3>
                </div>
            </LatestPostHeader>
            <LatestPostBox>
                {sideLatestPostsData &&
                    sideLatestPostsData.map((latestPosts, i) => {
                        return (
                            <SideLatestPosts
                                key={i}
                                title={latestPosts.node.jfrontmatter.title}
                                thume_image={
                                    latestPosts.node.localThume
                                }
                                date={latestPosts.node.jfrontmatter.date}
                                dateSlug={latestPosts.node.jfields.dateSlug}
                                slug={latestPosts.node.jfields.slug}
                            />
                        )
                    })}
            </LatestPostBox>
        </LatestPostInnerWrap>
    )
}

LatestPostArea.propTypes = {}

export default LatestPostArea
